import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=5b915588&scoped=true"
import script from "./vip.vue?vue&type=script&lang=js"
export * from "./vip.vue?vue&type=script&lang=js"
import style0 from "./vip.vue?vue&type=style&index=0&id=5b915588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b915588",
  null
  
)

export default component.exports